"use strict";
import ApiService from "./api_service";
import ObjectWithIDStore from "../stores/object_with_id_store";
import fetch from "../util/fetch";
import Account from "../api/account";
const carrier_term = Account.carrierTerm();
const CarrierService = function() {
  const store = new ObjectWithIDStore();
  const unknownCarrier = {
    id: "",
    name: "Unknown " + carrier_term
  };
  const self = this;
  const idsBeingFetched = {};
  function clean(name) {
    return name.toLowerCase().replace(/[& -]/g, "");
  }
  const isCurrentlyFetching = function(id) {
    return idsBeingFetched[id];
  };
  const fetching = function(id, promise) {
    idsBeingFetched[id] = promise;
  };
  const doneFetching = function(id) {
    delete idsBeingFetched[id];
  };
  this.carrierService = {
    store,
    carriers() {
      return _.sortBy(store.items, self.carrierService.carrierSort);
    },
    getCarrier(id) {
      return store.index[id];
    },
    getCarrierOrUnknown(id) {
      return self.carrierService.getCarrier(id) || unknownCarrier;
    },
    carrierWithId(carrierId) {
      if (store.index[carrierId]) {
        return Promise.resolve(store.index[carrierId]);
      }
      return self.carrierService.fetchAndReturnPromise(carrierId);
    },
    searchByName(name) {
      return self.carrierService.filterByName(name).slice(0, 20);
    },
    filterByName(name) {
      return _.select(
        _.sortBy(store.items, self.carrierService.carrierSort),
        (x) => _.str.startsWith(clean(x.name), clean(name))
      );
    },
    carrierSort(carrier) {
      return carrier.id === "" ? "A" : carrier.name;
    },
    createAddress(carrier, paymentStrategy, paymentDetails) {
      const details = { payment_strategy: paymentStrategy };
      if (paymentStrategy === "direct") {
        details.payment_address = paymentDetails;
      } else {
        details.factoring_company_office_id = paymentDetails.id;
      }
      return ApiService.addErrorHandler(
        $.post(
          `/api/carriers/${carrier.id}/payment_addresses`,
          details
        ).then(
          (result) => {
            store.addOrUpdate(result.carrier);
          }
        )
      );
    },
    updateCarrier(carrier) {
      const updatedCarrier = store.addOrUpdate(carrier);
      $(this).trigger("carrier_service:updated");
      return updatedCarrier;
    },
    updateCarriers(carriers) {
      const updatedCarriers = store.addOrUpdateAll(carriers);
      $(this).trigger("carrier_service:updated");
      return store.addOrUpdateAll(updatedCarriers);
    },
    fetchAndReturnPromise(carrierId) {
      if (carrierId) {
        let promise = isCurrentlyFetching(carrierId);
        if (!promise) {
          promise = ApiService.addErrorHandler(
            fetch(`/api/carriers/${carrierId}`).then(
              (result) => {
                const existing = store.addOrUpdate(result.carrier);
                doneFetching(carrierId);
                return existing;
              },
              _.identity
            )
          );
          fetching(carrierId, promise);
        }
        return promise;
      }
      return Promise.resolve(unknownCarrier);
    }
  };
};
const carrierService = new CarrierService();
export default carrierService;
